import { Card, Col, Row } from 'antd';
import { FC } from 'react';
import LoginForm from '../components/forms/login-form';

const LoginRoute: FC = () => {
  localStorage.clear()

  return (<>
    <Row
      justify="space-around"
      style={{ height: "100vh", alignItems: "center" }}
    >
      <Col>
        <Card style={{ width: 400 }}>
          <LoginForm />
        </Card>
      </Col>
    </Row>
  </>);
}

export default LoginRoute;
